import {translations} from 'presentation/translations-new';
import React from 'react';
import {
	StyledButton,
	StyledContainer,
	StyledContent,
	StyledDescription,
	StyledImage,
	StyledTitle,
} from './styles';
import type {BlogBannerItemProps} from './types';

const {seeMore} = translations['pt-br'].commons;

export const BlogBannerItem = ({
	title,
	description,
	imageUrl,
	imageAlt,
	linkUrl,
}: BlogBannerItemProps) => (
	<StyledContainer>
		<StyledImage src={imageUrl} alt={imageAlt} />
		<StyledContent>
			<StyledTitle>{title}</StyledTitle>
			<StyledDescription>{description}</StyledDescription>
			<StyledButton
				variant="text"
				size="small"
				onClick={() => window.open(linkUrl, '_blank', 'noopener,noreferrer')}>
				{seeMore}
			</StyledButton>
		</StyledContent>
	</StyledContainer>
);
